import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewModalModule } from 'outshared-lib';
import { RouterModule } from '@angular/router';
import {
    WucAccordionItemModule,
    WucAccordionModule,
    WucButtonModule,
    WucIconUiModule, WucLinkModule,
} from '@inshared/website-ui-components';
import { SalesfunnelRoutes } from '@inshared/shared/core';
import { AppRoutesEnum } from '@app/routes';

@Component({
    selector: 'ins-insurance-premium-determining-factor-moped-modal',
    templateUrl: './insurance-premium-determining-factor-moped.modal.html',
    standalone: true,
    imports: [
        CommonModule,
        NewModalModule,
        RouterModule,
        WucButtonModule,
        WucIconUiModule,
        WucAccordionItemModule,
        WucAccordionModule,
        WucLinkModule,
    ],
})
export class InsurancePremiumDeterminingFactorMopedModal {
    public salesfunnelRoutes = SalesfunnelRoutes;
    protected readonly appRoutesEnum = AppRoutesEnum;
}
